export const getIsMobile = state => state.browser.is.extraSmall || state.browser.is.small;
export const getIsTablet = state => state.browser.lessThan.large;

export const getIsMobileCourseCatalog = state =>
  state.browser.is.mobileCourseCatalog
    || state.browser.lessThan.mobileCourseCatalog
  ;

export const getWindowSize = state => state.browser.lessThan;
